export default "__VITE_ASSET__DSNtOxYI__"